import { Popover } from '@mui/material';
import React from 'react'
import './CustomSidePopover.css'



interface ICustomSidePopoverProps {
    id: string;
    children: JSX.Element;
    open: boolean;
    handleClose: ()=>void;
    popperClassName?: string;
    isBgBlack?:boolean;
}



const CustomSidePopover: React.FC<ICustomSidePopoverProps> = (props) => {
    const {id,children,open,handleClose,popperClassName,isBgBlack} = props;
  return (
   <Popover
        className="side__popover__container"
        id={id}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
        }}
        transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
        }}
        style={{ backgroundColor: isBgBlack ? 'rgba(0,0,0,0.5)' : 'none'}}
        marginThreshold={0}
        classes={{ paper: 'custom__side__popover__container-paper ' + popperClassName}}
    >
        {children}
    </Popover>
  )
}

export default CustomSidePopover